import { render, staticRenderFns } from "./Textareatype.vue?vue&type=template&id=34781aa2&"
import script from "./Textareatype.vue?vue&type=script&lang=js&"
export * from "./Textareatype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports